import { render } from "./VsTable.vue?vue&type=template&id=5436b4a3"
import script from "./VsTable.vue?vue&type=script&lang=js"
export * from "./VsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__